import { Expose } from 'class-transformer'

export class BookReadFreePromotion {
  @Expose() startedAt: string

  @Expose() endedAt: string
}
